export const Budget = ({size = 21, className = '', title = false}) => {
  return (
    <i style={{width: size, height: size}} className={`flex justify-center items-center ${className}`} title={title || undefined}>
      <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="4.5" y="13.5" width="3" height="4" rx="1" fill="#5D4634"/>
        <rect x="9.5" y="9.5" width="3" height="8" rx="1" fill="#93BDDD"/>
        <rect x="14.5" y="5.5" width="3" height="12" rx="1" fill="#F96733"/>
      </svg>
    </i>
  )
};

